import React from 'react';
import { ExpandableTable, useTheme } from '@hmsexp/component-library';
import { tableStyles } from './styles';
import { View } from '../react-native-components';
import get from 'lodash/get';
import TableCell from './TableCell';

const Table = ({ table_data, lowSampleSize, ...props }) => {
  const { expendable = false } = props;
  const theme = useTheme();
  const styles = tableStyles(theme);
  const rowData = get(table_data, 'table_rows', []);
  const sample_size_data = get(table_data, 'table_count', []);

  const sortColumns = get(table_data, 'sortColumns', []);

  const tableColumns = get(table_data, 'table_columns', []).map((column, index) => ({
    ...column,
    Cell: props => <TableCell {...props} ds={props} lowSampleSize={lowSampleSize} sample_size_data={sample_size_data} index={index} sortColumns={sortColumns} />
  }));

  return (
    <View style={styles.container}>
      <ExpandableTable
        hasNestedData={expendable}
        showTitleBar={false}
        isRowsScrollable={false}
        nestedKey='nested_rows'
        columns={tableColumns}
        data={rowData}
        collapsibleIconsDirection='left'
        showsHorizontalScrollIndicator={true}
        style={{
          container: styles.tableContainer,
          rowContainer: styles.rowContainer,
          headerContainer: styles.headerContainer,
          lastRowStyle: styles.lastRowStyle
        }}
      />
    </View>
  );
};

export default Table;